import React, { useState } from "react";

import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import connectComponent from "../../redux/connectComponent";
import { useForm } from "react-hook-form";

import { Error } from "components/errors";
import withWrap from "components/withWrap";
import Container from "components/container";
import {
  BoxForm,
  BoxHeadline,
  DescHeadline,
  InputForm,
  WButton
} from "components/BoxForm";

const AddHome = ({ actions }) => {
  const { register, handleSubmit, errors } = useForm();

  const [done, setDone] = useState(false);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [ooa, setOoa] = useState(false);

  const verify = (postal_code) => actions.validateHome(postal_code);

  const onSuccess = () => actions.refresh().then(() => setDone(true));

  const onFailure = (errorResponse) => {
    errorResponse.then((response) => {
      const message =
        response && (response.error || response.message || response.errors);
      setError(
        typeof message === "string"
          ? message
          : Array.isArray(message) && message.length > 0
          ? String(message[0])
          : "Something went wrong. Please try again."
      );
    });
  };

  const stopSubmitting = () => setSubmitting(false);

  const updateUser = (user) =>
    actions
      .updateUser(user)
      .then(onSuccess)
      .catch(onFailure)
      .finally(stopSubmitting);

  const onUpdate = (data) => {
    if (submitting) return;

    setSubmitting(true);

    const user = { postal_code: data.postal_code };

    return verify(user.postal_code)
      .then(() => true)
      .catch(() => false)
      .then((verified) => (verified ? updateUser(user) : setOoa(true)));
  };

  if (!submitting) {
    if (done) return <Redirect to="/dashboard" />;

    if (ooa) return <Redirect to="/ooa" />;
  }

  return (
    <Container>
      <BoxForm action="/" onSubmit={handleSubmit(onUpdate)}>
        <BoxHeadline>Almost done!</BoxHeadline>
        <DescHeadline>
          Enter your zip code so we can show you restaurants and meal options
          available in your area.
        </DescHeadline>
        <InputForm>
          <label htmlFor="postal_code">Zip Code</label>
          <input
            type="text"
            ref={register({ required: true, pattern: /^\d{5}$/ })}
            id="postal_code"
            name="postal_code"
            autoComplete="postal-code"
          />
          {errors.postal_code && <Error error="Valid zipcode required" />}
          {error && <Error error={error} />}
        </InputForm>

        <WButton
          type="submit"
          value={submitting ? "Submitting..." : "Finish"}
          data-testid="signup"
        />
      </BoxForm>
    </Container>
  );
};

AddHome.propTypes = {
  actions: PropTypes.object
};

export default withWrap(connectComponent(AddHome, ["authentication"]));
